import XLSX from "xlsx";


const convertToFloat = (data) => {

  const newArray = [...data]
  for (let i = 0; i < newArray.length; i++) {
    for (const index in newArray[i]) {
      let myString = newArray[i][index]
      if (myString) {
        if (myString[0] === "(" && myString[myString?.length - 1] === ")") {
          myString = myString.replaceAll("(", "")
          myString = myString.replaceAll(")", "")
          myString = parseFloat(myString) * (-1)
          newArray[i][index] = myString
        }
      }

      if (!index.includes('تاریخ')) {
        if (parseFloat(myString)) {
          newArray[i][index] = parseFloat(myString)
        }
      }
    }
  }
  return newArray
}
const convertToCSV1 = (objArray: string) => {
  const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  let str = "";

  for (let i = 0; i < array.length; i++) {
    let line = "";
    for (const index in array[i]) {
      if (line != "") line += ",";

      line += array[i][index];
    }

    str += line + "\r\n";
  }

  return str;
};
const convertToCSV = (objArray: string) => {
  const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  let str = "";

  for (let i = 0; i < array.length; i++) {
    let line = "";
    for (const index in array[i]) {
      if (line !== "") line += ",";
      // Format numbers as numbers, other values as strings
      const value = typeof array[i][index] === "number" ? array[i][index] : `"${array[i][index]}"`;
      line += value;
    }

    str += line + "\r\n";
  }

  return str;
};


const exportCSVFile = (
  data: { [key: string]: any }[],
  fileTitle: string,
  headers?: { [key: string]: string }[]
) => {
  const items = JSON.parse(JSON.stringify(data));
  if (headers) {
    items.unshift(headers);
  } else {
    let obj: { [key: string]: string } = {};
    Object.keys(items[0]).map((value) => {
      obj[value] = value;
    });

    items.unshift(obj);
  }

  // Convert Object to JSON
  const jsonObject = JSON.stringify(items);
  const exportedFileName = fileTitle + ".csv" || "export.csv";

  const utf8BOM = "\uFEFF";
  debugger
  const csvContent = convertToCSV(jsonObject);
  const blob = new Blob([utf8BOM, csvContent], {type: "text/csv;charset=utf-8;"});

  const link = document.createElement("a");
  if (link.download !== undefined) {
    // feature detection
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", exportedFileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
export const exportXLSXFile = (
  data: { [key: string]: any }[],
  fileTitle: string,
  headers?: { [key: string]: string }[]
) => {

  data = convertToFloat(data)

  const items = JSON.parse(JSON.stringify(data));
  const worksheet = XLSX.utils.json_to_sheet(items);
  if (headers) {
    items.unshift(headers);
  } else {
    let obj: { [key: string]: string } = {};
    Object.keys(items[0]).map((value) => {
      obj[value] = value;
    });

    items.unshift(obj);
  }

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, worksheet, "Sheet1");

  // Create a Blob with XLSX format
  const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
  const blob = new Blob([wbout], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });

  const exportedFileName = fileTitle + ".xlsx" || "export.xlsx";

  const link = document.createElement("a");
  if (link.download !== undefined) {
    // Browsers that support HTML5 download attribute
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", exportedFileName);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

export default exportCSVFile;
